var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let counter = 0;
const globalAny = global;
/**
 * This is used to make the execution delayed
 *  @param {number} ms - time in milliseconds to get delayed
 *  @returns { Promise<number> }
 */
export const getSleep = (ms) => new Promise(resolve => {
    setTimeout(resolve, ms);
});
/* Helpers wrapper is required for test mocking */
export const helpers = {
    getSleep
};
/**
 * Returns black box values by checking whether its present in the global object window.IGLOO, if not present it checks maximum 10 times for it to return blackbox value data.
 * @returns { blackbox: string,  finished: boolean}
 */
const getBlackBoxValues = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const blackboxValues = ((_b = (_a = globalAny.window) === null || _a === void 0 ? void 0 : _a.IGLOO) === null || _b === void 0 ? void 0 : _b.getBlackbox)
        ? globalAny.window.IGLOO.getBlackbox()
        : {};
    if (!blackboxValues.finished && counter < 10) {
        counter += 1;
        yield helpers.getSleep(500);
        return getBlackBoxValues();
    }
    return blackboxValues;
});
export default getBlackBoxValues;
